var intercom = {
  elements: [],

  init: function() {
    this.getElements();
    this.triggerIntercom();
  },

  getElements: function() {
    this.elements.intercomLink = jQuery('.intercom-link');
  },

  triggerIntercom: function() {
    _self = this;

    if (!_self.elements.intercomLink.length) return false;

    _self.elements.intercomLink.on('click', function() {
      Intercom('show');
    })
  }
}

intercom.init(); 